import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {PauseCircleIcon} from 'shells/icon/svg/pause-circle-icon';
// @ts-expect-error - imported from .js/.jsx file
import {StopCircleIcon} from 'shells/icon/svg/stop-circle-icon';

export type Variant = 'DRAFT' | 'PAUSED' | 'RETIRED' | 'CANCELLED' | 'ARCHIVED' | 'PROBLEM';

export function getColor(variant: Variant | null | undefined, defaultColor: string) {
    let color = defaultColor;

    if (variant && variant === 'DRAFT') {
        color = colors.blueDk;
    }

    if (variant && variant === 'PAUSED') {
        color = colors.orange;
    }

    if ((variant && variant === 'RETIRED') || variant === 'CANCELLED') {
        color = colors.roseDk;
    }

    return color;
}

export function getIcon(
    variant: Variant | null | undefined,
    defaultIcon: React.ComponentType<any>
) {
    let icon = defaultIcon;

    if (variant && variant === 'PAUSED') {
        icon = PauseCircleIcon;
    }

    if ((variant && variant === 'RETIRED') || variant === 'CANCELLED') {
        icon = StopCircleIcon;
    }

    return icon;
}
